export const SUPPORT_LINK =
  'https://witmetrics.atlassian.net/servicedesk/customer/portals';
